<template>
  <div class="tv-list">
    <div
      v-if="listDatas && listDatas.length"
      class="tool-wrap"
    >
      <a-button
        type="primary"
        @click="handleAdd"
      >
        {{ $t('message[1789]') }}
      </a-button>
    </div>
    <a-table
      v-if="listDatas && listDatas.length"
      row-key="id"
      :columns="columns"
      :data-source="listDatas"
      :loading="loading"
      :pagination="false"
      :locale="{
        'emptyText': $t('message[1823]')
      }"
    >
      <template
        slot="name"
        slot-scope="text, record"
      >
        <span>{{ text }}</span>
        <span
          class="status-text"
          :class="{'fs-green': record.status === 1}"
        >
          {{ record.status === -1 ? listStatusName[1] : record.status === 1 ? listStatusName[0] : '' }}
        </span>
      </template>
      <template
        slot="type"
        slot-scope="text"
      >
        {{ typeMap[text] }}
      </template>
      <template
        slot="action"
        slot-scope="text,record"
      >
        <a
          v-if="record.status !== -1"
          @click="handleCode(record)"
        >
          {{ $t('message[1786]') }}
        </a>
        <a
          v-if="record.status !== -1"
          href="javascript:;"
          @click="handleEdit(record)"
        >{{ $t('message[36]') }}</a>
        <a @click="handleClose(record)">
          {{ record.status === -1 ? statusName[1] : record.status === 1 ? statusName[0] : '' }}
        </a>
        <a @click="handleDelete(record)">
          {{ $t('message[962]') }}
        </a>
      </template>
    </a-table>
    <div
      v-if="loading === false && !listDatas.length"
      class="empty-box"
    >
      <img
        src="@/assets/images/logo-gray.png"
        alt=""
        class="logo"
      >
      <p>{{ $t('message[1823]') }}</p>
      <a-button
        type="primary"
        class="add-btn2"
        @click="handleAdd"
      >
        {{ $t('message[1789]') }}
      </a-button>
    </div>

    <code-modal
      :visible.sync="showModal"
      :preview-code="previewCode"
      :title="$t('message[1786]')"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CodeModal from './CodeModal'

export default {
  components: {
    CodeModal
  },
  data () {
    return {
      showModal: false,
      previewCode: ''
    }
  },
  computed: {
    ...mapState('config/tv', ['columns', 'listDatas', 'loading', 'allConfig', 'layoutTypeOptions']),

    typeMap () {
      let obj = {}
      for (let item of this.layoutTypeOptions) {
        obj[item.id] = item.name
      }
      return obj
    },
    statusName (record) {
      let str = this.$t('message[1204]')
      let arr = str.split('|')
      return arr
    },
    listStatusName (record) {
      let str = this.$t('message[1818]')
      let arr = str.split('|')
      return arr
    }
  },
  async created () {
    await this.fetchTvList()
  },
  methods: {
    ...mapActions('config/tv', [
      'fetchTvList',
      'delConfig',
      'closeConfig',
      'openConfig',
      'fetchCode'
    ]),
    handleAdd () {
      this.$router.push({
        name: 'configAddTv'
      })
    },

    handleEdit (record) {
      this.$router.push({
        name: 'configTvDetail',
        params: {
          id: record.id
        }
      })
    },
    /**
     * 获取code
     */
    async handleCode (record) {
      const chain = await this.fetchCode({ id: record.id, type: 1 })
      chain
        .onSuccess(res => {
          const { code = '' } = res
          this.showModal = true
          this.previewCode = code
        })
      this.showModal = true
    },
    /**
     * 启用/停用
     */
    async handleClose (record) {
      let { status } = record // 停用: -1  启用: 1
      let chain
      if (status === -1) {
        chain = await this.openConfig({ id: record.id, type: 1 })
      } else if (status === 1) {
        chain = await this.closeConfig({ id: record.id, type: 1 })
      }

      chain
        .onNetSuccess((res = {}) => {
          const { error, payload } = res.data || {}
          const { type, data = [] } = payload || {}
          if (error === 100 && type === 2) {
            this.$message.destroy()
            const arr = []
            for (let i = 0; i < data.length; i++) {
              const item = data[i]
              if (i !== data.length - 1) {
                arr.push(<span>{ item.name }<i>、</i></span>)
              } else {
                arr.push(<span>{ item.name }</span>)
              }
            }
            // 如需停用，请先将其从下列组合中删除：
            const content = <div>{ this.$t('message[1929]') }<p class="delete-arr">{arr}</p></div>
            this.$confirm({
              title: this.$t('message[1930]'), // 在组合中使用的屏幕无法停用
              content: content,
              closable: true,
              okText: this.$t('message[1597]'), //  知道了
              okType: 'primary',
              cancelText: '',
              class: 'confirm-warn-modal knew-modal',
              onOk: async () => {}
            })
          }
        })
        .onSuccess(res => {
          this.fetchTvList()
        })
    },
    /**
     * 删除大屏
     */
    async handleDelete (record) {
      this.$confirm({
        title: this.$t('message[1814]'), // '删除当前数据大屏',
        content: this.$t('message[1815]'), // '删除后正在使用的数据大屏将不能使用， 确定要删除吗？',
        closable: true,
        okText: this.$t('message[915]'), // 确定
        okType: 'primary',
        cancelText: this.$t('message[896]'), // 取消
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.delConfig({ id: record.id, type: 1 })
          chain
            .onNetSuccess((res = {}) => {
              const { error, payload } = res.data || {}
              const { type, data = [] } = payload || {}
              if (error === 100 && type === 2) {
                this.$message.destroy()
                const arr = []
                for (let i = 0; i < data.length; i++) {
                  const item = data[i]
                  if (i !== data.length - 1) {
                    arr.push(<span>{ item.name }<i>、</i></span>)
                  } else {
                    arr.push(<span>{ item.name }</span>)
                  }
                }
                // 如需删除，请先将其从下列组合中删除：
                const content = <div>{ this.$t('message[1931]') }<p>{ arr }</p></div>
                this.$confirm({
                  title: this.$t('message[1932]'), // 在组合中使用的屏幕无法删除
                  content,
                  closable: true,
                  okText: this.$t('message[1597]'), //  知道了
                  okType: 'primary',
                  cancelText: '',
                  class: 'confirm-warn-modal knew-modal',
                  onOk: async () => {}
                })
              }
            })
            .onSuccess(res => {
              this.fetchTvList()
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tv-list {
  margin-bottom: 60px;
}
.ant-table-wrapper ::v-deep {
  .ant-table-tbody > tr > td {
    vertical-align: top;
  }
}
.status-text{
  position: relative;
  height: 20px;
  line-height: 20px;
  margin-left: 12px;
  padding: 0 4px 0 11px;
  font-size: 12px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EBEBEB;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 4px;
    bottom: 0;
    width: 4px;
    height: 4px;
    margin: auto 0;
    background-color: #E0E0E0;
    border-radius: 4px;
  }
  &.fs-green::before {
    background-color: #42C27E;
  }
}
a {
  margin-right: 16px;
  &:last-child {
    margin-right: 0;
  }
}
.tool-wrap {
  margin-bottom: 24px;
}

.empty-box {
  text-align: center;
  .logo {
    width: 40px;
    height: 40px;
    margin: 120px auto 24px;
    background-size: 100%;
  }
  p {
    color: #b3b3b3;
  }
  .add-btn2 {
    display: block;
    margin: 24px auto;
  }
}

</style>
